import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import styled from 'styled-components';
const AnimationWrapper = styled.div.withConfig({
  displayName: "LoaderBar__AnimationWrapper",
  componentId: "cqk1jc-0"
})(["@keyframes pulse{0%{opacity:0.5;box-shadow:0 0 0 0 rgba(0,0,0,0.7);}70%{opacity:1;box-shadow:0 0 0 5px rgba(0,0,0,0);}100%{opacity:0.5;box-shadow:0 0 0 0 rgba(0,0,0,0);}}"]);
const withStyles = makeStyles(theme => ({
  bar: {
    backgroundColor: theme.palette.text.secondary
  }
}));
export const LoaderBar = ({
  value
}) => {
  const uiValue = value === 0 ? 1 : value;
  const classes = withStyles();
  const wrapperStyle = {
    width: '100%',
    height: '1.5vh',
    maxHeight: '15px',
    border: '1px solid black',
    borderRadius: '1vw',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  };
  const barStyle = {
    height: '100%',
    width: `${uiValue * 100}%`,
    borderRadius: '1vw',
    animation: 'pulse 2s infinite'
  };
  return /*#__PURE__*/React.createElement(AnimationWrapper, null, /*#__PURE__*/React.createElement("div", {
    style: wrapperStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.bar,
    style: barStyle
  })));
};